module.exports = __webpack_public_path__ + "media/images/product/p_j-f136cf19fca6fb377d745a1094984864.png";